export default {
    PRINTERS: 'printers',
    COUPON: 'coupon',
    LIMITED_RESOURCES: 'limited_resources',

    all() {
        return [
            this.PRINTERS,
            this.COUPON,
            this.LIMITED_RESOURCES,
        ]
    },

    isEnabled(feature, enabledFeatures) {
        return enabledFeatures.includes(feature)
    }
}
